module.exports = __webpack_public_path__ + "static/media/logoGO2.8bbc64ed.png";